module.exports = __webpack_public_path__ + "img/btn_floating_closed.00046d3b.svg";